<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-12 md:py-12 py-8" id="getACallBack">
    <div class="lg:pb-12 mdpb-10 pb-6">
      <p class="fsize38 sm-fsize22 font-semibold clr-black text-center">
        Invest in your People. Get in Touch Today!
      </p>
    </div>
    <div class="w-60per md-wfull sm-wfull mx-auto">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="lg:flex md:flex gap-4 lg:mb-6 md:mb-6 mb-4">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
              <p class="fsize12 clr-black">
                Full Name<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your first name"
                name="name"
                :rules="{ required: true, alpha_spaces: true }"
                v-model="name"
              ></base-input>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <p class="fsize12 clr-black">Phone Number</p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your phone number"
                name="phone number"
                :rules="{ required: true, numeric: true }"
                v-model="mobile"
              ></base-input>
            </div>
          </div>
          <div class="lg:flex md:flex gap-4 lg:mb-6 md:mb-6 mb-4">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
              <p class="fsize12 clr-black">
                Company Name<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your company name"
                :rules="{ required: true }"
                name="companyName"
                v-model="companyName"
              ></base-input>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <p class="fsize12 clr-black clr-black">
                Email Address<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                :rules="{ required: true, email: true }"
                placeholder="Enter your email address"
                name="email"
                v-model="email"
              ></base-input>
            </div>
          </div>
          <div class="lg:flex md:flex gap-4 lg:mb-6 md:mb-6 mb-4">
            <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
              <p class="fsize12 clr-black">
                Your Designation<span class="clr-red">*</span>
              </p>
              <base-input
                class="rounded-lg w-full"
                placeholder="Enter your designation"
                name="designation"
                :rules="{ required: true }"
                v-model="designation"
              ></base-input>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full">
              <p class="fsize12 clr-black">
                Which Services is Your Organisation Interested in?<span
                  class="clr-red"
                  >*</span
                >
              </p>

              <el-select
                class="w-full rounded-lg"
                v-model="services"
                placeholder="Ex: ESG/CSR Initiative"
              >
                <el-option
                  v-for="item in servicesOptionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <b-form-select
                v-model="services"
                name="services"
                required
                placeholder="Please select a service"
                :options="servicesOption"
                class="w-full rounded-lg"
                value-field="value"
                text-field="label"
              >
              </b-form-select> -->
            </div>
          </div>
          <div class="w-full mb-4">
            <p class="fsize12 clr-black">
              Please give us more details about your organisation's needs<span
                class="clr-red"
                >*</span
              >
            </p>
            <base-input
              type="textarea"
              class="rounded-lg w-full"
              :rows="3"
              placeholder="Enter what your organisation needs and how we can help."
              :rules="{ required: true }"
              name="description"
              v-model="description"
            >
            </base-input>
          </div>
          <div>
            <p class="fsize12">
              <span class="clr-red">*</span> Indicates a required field
            </p>
          </div>
          <div class="mt-6 w-full">
            <el-checkbox class="w-full" v-model="checked1"
              >By submitting the form, you agree to our terms of <br />
              conditions and privacy policy.</el-checkbox
            >
            <el-checkbox class="w-full" v-model="checked2"
              >Signup for newsletter.</el-checkbox
            >
          </div>
          <div class="text-center lg:mt-10 md:mt-10 mt-6">
            <b-button
              :disabled="!checked1"
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
            >
              Submit Form</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      designation: "",
      description: "",
      companyName: "",
      services: "Please select a service",
      servicesOption: [],
      servicesOptionList: [
        {
          ladel: "Advisory Support Services for Caregiver Well-being",
          value: "Advisory Support Services for Caregiver Well-being",
        },
        {
          ladel: "Employee Well-being Services",
          value: "Employee Well-being Services",
        },
        { ladel: "Learning Interventions", value: "Learning Interventions" },
        { ladel: "ESG/CSR Initiatives", value: "ESG/CSR Initiatives" },
        { ladel: "Experience Centre", value: "Experience Centre" },
        { ladel: "Future fit Initatives", value: "Future fit Initatives" },
        {
          ladel: "Arrange the Experience Centre at Your Organization",
          value: "Arrange the Experience Centre at Your Organization",
        },
        { ladel: "Get a Call Back", value: "Get a Call Back" },
        {
          ladel: "Organize a webinar today",
          value: "Organize a webinar today",
        },
      ],
      textarea: "",
      input: "",
      value: "",
      checked1: false,
      checked2: false,
    };
  },
  watch: {
    async selectservice(val) {
      if (val === "Arrange the Experience Centre at Your Organization") {
        this.services = this.servicesOptionList[6].value;
        // await this.$store.commit("ffc/setselectservice", false);
      } else if (val === "Get a Call Back") {
        this.services = this.servicesOptionList[7].value;
      } else if (val === "Organize a webinar today") {
        this.services = this.servicesOptionList[8].value;
      }
    },
  },
  methods: {
    async handleCreate() {
      try {
        let payload = {
          name: this.name,
          mobile: this.mobile,
          email: this.email,
          companyName: this.companyName,
          designation: this.designation,
          services: this.services,
          description: this.description,
        };
        let data = await this.$store.dispatch("ffc/add_form", payload);
        console.log(data);
        this.$swal.fire({
          title: "Added",
          text: "Added Successfully!",
          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        this.resetForm();
      } catch (error) {
        console.log(error);
      }
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.services = "";
      this.designation = "";
      this.description = "";
      this.companyName = "";
      this.checked1 = false;
      this.checked2 = false;
      this.$refs.formValidator.reset();
    },
    capitalizeFirstLetter: function (str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
  computed: {
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("ffc", { selectservice: "selectservice" }),
    ...mapState("auth", ["user"]),
  },
  async mounted() {
    console.log(this.user, "2222");

    try {
      if (this.user && this.user.firstname && this.user.lastname) {
        this.name = `${this.capitalizeFirstLetter(
          this.user.firstname
        )} ${this.capitalizeFirstLetter(this.user.lastname)}`;
      } else {
        this.name = "";
      }

      this.mobile = this.user ? this.user.mobile : "";
      this.email = this.user ? this.user.email : "";

      const getServices = await this.$store.dispatch("services/get_all");
      this.servicesOption = this.get_AllService.result.map((ele) => ({
        value: ele.title,
        label: ele.title,
      }));
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
